import { createAction } from 'redux-actions';

export const GetSettingProductCompanyRequested = createAction('GET_SETTING_PRODUCT_COMPANY_REQUESTED');
export const GetSettingProductCompanyRequestedReceived = createAction('GET_SETTING_PRODUCT_COMPANY_REQUESTED_RECEIVED');
export const GetSettingProductCompanyRequestedReceivedFailure = createAction('GET_SETTING_PRODUCT_COMPANY_REQUESTED_RECEIVED_FAILURE');
export const ClearSettingProductCompany = createAction('CLEAR_SETTING_PRODUCT_COMPANY');

export const UpdateSettingProductCompanyRequested = createAction('UPDATE_SETTING_PRODUCT_COMPANY_REQUESTED');
export const UpdateSettingProductCompanyRequestedReceived = createAction('UPDATE_SETTING_PRODUCT_COMPANY_REQUESTED_RECEIVED');
export const UpdateSettingProductCompanyRequestedReceivedFailure = createAction('UPDATE_SETTING_PRODUCT_COMPANY_REQUESTED_RECEIVED_FAILURE');
export const ClearUpdate = createAction('CLEAR_UPDATE');
